/* eslint-disable */
import { Metrics, Colors, Fonts } from '../../Themes'
import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  container: {
  borderColor: `black`,
  borderWidth : 1
   
  },
  
  avatarBorder: {
    paddingTop: 2,
    paddingLeft: 2,
    height: 90,
    width: 90,
  },
  disableText : {
    color: Fonts.style.color.disable
  },
  avatar: {
    height: 90,
    width: 90,
    borderRadius: 45,
    borderColor: 'black',
    borderWidth : 2
  },
})
